/* global $, getCSRFToken */
import { SOMETHING_WENT_WRONG_GOING_TO_RELOAD } from 'mk/autogenerated/translations/jquery.ajax.csrf.62948cbb5a8cd4dfb3089ea49caa41cc'

// we setup jquery so that ajax correctly does django-csrf
export function initJqueryAjaxCsrf() {
    var initialCSRFToken = getCSRFToken();

    function safeMethod(method) {
        return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
    }

    $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
        var apiVersion = window.MK_API_VERSION_STRING;

        // for CORS requests, if we start to add this header
        // they will need to be "preflighted", and that makes
        // complications. perhaps we should do it anyway,
        // but then we have to start to implement preflighting
        // which might be maybe as simple as a decorator
        // in django, but still, need to be implemented
        if (apiVersion && (!options.crossDomain)) {
            jqXHR.setRequestHeader('X-Api-Version', apiVersion);
        }

        var currentCSRFToken = getCSRFToken();

        if (currentCSRFToken !== initialCSRFToken) {
            // this is bad. it can happen when
            // the user re-logins in an another tab
            // and then comes back to this tab to do something
            jqXHR.abort();
            window.alert(SOMETHING_WENT_WRONG_GOING_TO_RELOAD);
            window.location.reload();
        }

        if ((!safeMethod(options.type)) && (!options.crossDomain)) {
            jqXHR.setRequestHeader('X-CSRFToken', currentCSRFToken);
        }
    });
}
